import { View } from '@react-pdf/renderer';

import { Table } from '../../../../../components/pdf';
import { Column } from '../../../../../components/pdf/tables/Table.types';
import { TEXT_CONTENT } from '../../../../../utils/constants';
import {
  getScenarioDetailColumns,
  summaryTableColumns,
} from './tableColumnDef';

export default function PdfCompareShiftMap({
  tableData,
  summaryData,
}: {
  tableData: any[];
  summaryData: any[];
}) {
  return (
    <View style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Table
        title={TEXT_CONTENT.SHIFTS_DETAILS}
        rows={tableData || []}
        columns={getScenarioDetailColumns() as Column[]}
      />
      <Table
        title={TEXT_CONTENT.SHIFTS_DETAILS_SUMMARY}
        rows={summaryData || []}
        columns={(summaryTableColumns as Column[]) || []}
      />
    </View>
  );
}
